import { ContentItem, ImisResponseItems } from "../models/imis.models";
import { RestUtility } from "./rest.utility";

export class iPartUtility {
    public static async getIpartSettings(contentKeySelector: string, contentItemKeySelector: string): Promise<any> {
        let contentKey = jQuery(contentKeySelector).val().toString();
        let contentItemKey = jQuery(contentItemKeySelector).val().toString();

        return this.getIpartSettingsByKeys(contentKey, contentItemKey);
    }

    public static async getIpartSettingsByKeys(contentKey: string, contentItemKey: string): Promise<any> {
        let iPartSettings = {};

        let contentItemResponse = await RestUtility.restApiGetData<ImisResponseItems<ContentItem>>("/api/contentitem", { contentKey, contentItemKey });
        if (contentItemResponse.Items == null) {
            // non-cloud
            iPartSettings = (<any>contentItemResponse).Settings;
        } else {
            // cloud
            let contentItem = contentItemResponse.Items[0];
            if (contentItem != null) {
                iPartSettings = contentItem.Data.Settings;
            }
        }

        return iPartSettings;
    }

    public static hideAndDefaultImisIpartSettings(hideDefaultSettings: boolean = false) {
        // default the "do not render in design mode" option to true
        let renderInDesignModeInput = document.querySelector<HTMLInputElement>("[id$=_DoNotRenderInDesignMode_CheckBoxSet]");
        renderInDesignModeInput.checked = true;

        // hide all the other out of the box iMIS iPart settings
        if (hideDefaultSettings) {
            document.querySelector<HTMLDivElement>("[id$=_iPartTitlePanel]").style.display = "none";
        }
    }

    public static initializeIpartSettingsConfiguration(settingElementSelector: any): any {
        // get all unique setting keys
        let iPartSettings = {};
        let jSettingElements = jQuery<HTMLElement>(settingElementSelector);
        let settingNames: string[] = this.getSettingNames(jSettingElements);

        // set settings to default empty values
        // this populates iPartSettings with the expected setting names
        settingNames.forEach(name => {
            let jSetting = this.getSettingElementsByName(jSettingElements, name);
            this.updateSettingValue(iPartSettings, name, jSetting);
        });

        // get settings from hidden json input if available and sync with setting elements
        let jJsonSettings = this.getJsonSettingsInput();
        if (jJsonSettings.length != 0) {
            let settingsString = jJsonSettings.val().toString();

            if (!VAIMISUtilityV2.General.isStringNullOrEmpty(settingsString)) {
                let settingsObject = JSON.parse(settingsString);
                Object.keys(settingsObject).forEach((settingName) => {
                    if (settingName in iPartSettings) {
                        iPartSettings[settingName] = settingsObject[settingName];
                    } else {
                        console.warn(`Setting with name ${settingName} does not match an existing setting element and has been removed`);
                    }
                });

                this.updateSettingElements(iPartSettings, jSettingElements);
            }
        } else {
            console.warn("JSON settings not available on initialization");
        }

        // track settings for changes and update
        settingNames.forEach(name => {
            let jSetting = this.getSettingElementsByName(jSettingElements, name);
            jSetting.on("change", () => {
                this.updateSettingValue(iPartSettings, name, jSetting);
                this.serializeSettings(iPartSettings);
            });
        });

        // initial serialization of settings
        this.serializeSettings(iPartSettings);
        return iPartSettings;
    }

    public static updateSettingElements(iPartSettings: any, jSettingElements: JQuery<HTMLElement>) {
        Object.keys(iPartSettings).forEach((settingName) => {
            let value = iPartSettings[settingName];

            let jSettingNameElements = this.getSettingElementsByName(jSettingElements, settingName);
            if (jSettingNameElements.length != 0) {
                this.setSettingElementValueByType(jSettingNameElements, value);
            } else {
                console.warn("Element for setting does not exist with the following values: ", settingName, value);
            }
        });
    }

    public static getSettingElementValueByType(jSettingElements: JQuery<HTMLElement>) {
        let value;

        if (this.isSettingElementTypeText(jSettingElements)) {
            value = jSettingElements.val();
        } else if (this.isSettingElementTypeRadio(jSettingElements)) {
            // this could possibly involve more than one radio button, filter out the unchecked ones and get the value
            value = jSettingElements.filter(":checked").val();
        } else {
            value = jSettingElements.prop("checked");
        }

        return value;
    }

    public static setSettingElementValueByType(jSettingElements: JQuery<HTMLElement>, newValue) {
        // this works for a select tag too because it will be null
        if (this.isSettingElementTypeText(jSettingElements)) {
            jSettingElements.val(newValue);
        } else if (this.isSettingElementTypeRadio(jSettingElements)) {
            // this could possible involve more than one radio element, select the one with the matching value
            jSettingElements.filter(`[value=${newValue}]`).prop("checked", true);
        } else {
            jSettingElements.prop("checked", newValue);
        }
    }

    public static updateSettingValue(iPartSettings: any, settingName: string, jSettingElements: JQuery<HTMLElement>) {
        iPartSettings[settingName] = this.getSettingElementValueByType(jSettingElements);
    }

    public static serializeSettings(jsonSettings) {
        let input = this.getJsonSettingsInput();

        if (input.length != 0) {
            input.val(JSON.stringify(jsonSettings));
        } else {
            console.warn("json settings not available::", JSON.stringify(jsonSettings));
        }
    }

    public static getJsonSettingsInput(): JQuery<HTMLInputElement> {
        return jQuery("#JsonSettings");
    }

    public static getSettingElementsByName(jSettingElements: JQuery<HTMLElement>, settingName: string): JQuery<HTMLElement> {
        return jSettingElements.filter(`[name=${settingName}]`);
    }

    private static getSettingNames(jSettingElements: JQuery<HTMLElement>): string[] {
        let settingKeys: string[] = [];

        jSettingElements.map(function () { return this.getAttribute("name") }).get().forEach(settingKey => {
            if (!settingKeys.includes(settingKey)) {
                settingKeys.push(settingKey);
            }
        });

        return settingKeys;
    }

    private static isSettingElementTypeText(jSettingElement: JQuery<HTMLElement>): boolean {
        let type = jSettingElement.attr("type");
        return !["checkbox", "radio"].includes(type);
    }

    private static isSettingElementTypeRadio(jSettingElement: JQuery<HTMLElement>): boolean {
        let type = jSettingElement.attr("type");
        return type == "radio";
    }
}